import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetAllStates } from "../../store/quotationSlice";

// Component to reset quotation states on mount - use this to clear stuck modals
function QuotationStateReset() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Reset all quotation states when component mounts
    dispatch(resetAllStates());
    console.log("Quotation states reset");
  }, [dispatch]);

  return null; // This component doesn't render anything
}

export default QuotationStateReset;